import { isNullOrUndefined } from 'util';
import * as dayjs from 'dayjs';
export class Helper {
    getTime(time) {
        if (!isNullOrUndefined(time)) {
            return new Date(time.match(/\d+/)[0] * 1);
        }
        else {
            return;
        }
    }
    getTimeForDmTimeFormat(time) {
        if (!isNullOrUndefined(time)) {
            return new Date(time.year, time.month - 1, time.day, time.hour, time.minute); // - 1 because the moth counting begins with 0
        }
        else {
            return;
        }
    }
    /**
     * gets an array out of an enum
     * @param enumIdentifier
     */
    getEnum(enumIdentifier) {
        return Object.keys(enumIdentifier)
            .map((key) => enumIdentifier[key])
            .filter((value) => typeof value === 'number');
    }
    /**
     * Returns formatted dateTime string for a given Date object in the optional
     * string format, or in a default format
     * @param dateTime The date to be formatted
     * @param format A date format string, e.g. 'DD.MM.YYYY HH:mm"
     * @returns {string}
     */
    formatDateTime(dateTime, format = 'DD. MMM, HH:mm') {
        return dayjs(dateTime).format(format);
    }
}
